export default "mutation getCustomerForgotPasswordLink($email: String!) {\n  getCustomerForgotPasswordLink(email: $email)\n}\n";